<template>
    <div id="project-list" class="row">
        <h1>Projects</h1>

        <!-- Search -->
        <CurrentSearch
            :show="searching"
            :currentSearch="search.current"
            @clear="ClearSearch()"
        />
        <div id="mobile-search" class="btn align-r" @click="Search()" v-if="mobile">
            <img src="@/assets/Images/IconSearchActive.png" alt="Icon - Search" title="Search" width="40" height="40"/>
        </div>

        <Category
            v-for="(category, c) in projects"
            :key="c"
            :category="category"
            :priority="Priority(category.Category)"
            :mobile="mobile"
            :selectedProject="selectedProject"
            :searching="searching"
            @project="$emit('project', $event)"
        />
    </div>

    <Popup
        :popup="popup"
        @close="ClosePopup('Popup')"
        @set-search="SEARCH.Set(this, $event)"
        @save-search="SaveSearch()"
        @deselect-all-types="SEARCH.DeselectAllSearchTypes(this)"
    />
    <SimplePopup
        :popup="simplePopup"
        :showOverlay="true"
        @close="ClosePopup('Simple')">
        <div class="single">
            <p>Changes were made. Are you sure you want to close without applying them?</p>
            <Button
                :type="BUTTON_TYPES.prominent"
                value="Yes"
                position="right"
                @click="ForceClosePopup()"
            />
            <Button
                :type="BUTTON_TYPES.off"
                value="No"
                position="right"
                class="margin-tr"
                @click="ClosePopup('Simple')"
            />
        </div>
    </SimplePopup>
</template>

<script>
import Category from "@/components/Projects/CategoryList/Category.vue";
import Popup from "@/components/Popups/Popup.vue";
import SimplePopup from "@/components/Popups/Simple.vue";
import Button from "@/components/Button.vue";
import CurrentSearch from "@/components/Projects/CurrentSearch/CurrentSearch.vue";
import PriorityTypes from "@/assets/JS/Data/Navigation.json";
import {
    BUTTON_TYPES,
    SEARCH,
    ASSETS
} from "@/assets/JS/Assets.js";
import { searchModel } from "@/models/";

export default {
    name: "PrejectList",
    props: {
        projects: Array,
        mobile: Boolean,
        selectedProject: Object,
        projectTypes: Array
    },
    components: {
        Category,
        Popup,
        SimplePopup,
        Button,
        CurrentSearch
    },
    data: () => ({
        popup: {},
        simplePopup: {},
        BUTTON_TYPES,
        ...searchModel.data,
        searching: false,
        SEARCH
    }),
    methods: {
        Priority: function(category) {
            return PriorityTypes.Projects.PriorityTypes.filter(p => p.Name === category)[0];
        },
        Search: function() {
            this.popup = {
                show: true,
                title: "Search",
                content: "Search",
                topography: 1000,
                search: this.search
            };
            this.search.changeMade = false;
        },
        SaveSearch: function() {

            // Set filters for projects
            const types = [];
            for (const type of this.search.types) {
                if (type.selected) {
                    types.push(type.value);
                }
            }
            this.search.current = { Types: types };

            // Get total of filtered by category
            for (const category of this.projects) {
                for (const type of category.Types) {
                    this.search.categoryFilteredTotal = 0;
                    for (const project of type.Projects) {
                        project.ProjectTypes = this.projectTypes.filter(t => t.ProjectID === project.ProjectID);
                        for (const projectType of project.ProjectTypes) {
                            if (types.indexOf(projectType.Name) !== -1) {
                                this.search.categoryFilteredTotal++;
                            }
                        }
                        project.search = {
                            filterID: this.search.categoryFilteredTotal - 1,
                            types
                        };
                    }
                    type.CategoryFilteredTotal = this.search.categoryFilteredTotal;
                }
            }

            this.searching = types.length > 0;
            this.search.changeMade = false;
            this.ClosePopup("Popup");
        },
        ClearSearch: function() {
            SEARCH.DeselectAllSearchTypes(this);
            this.searching = false;
            this.search.current = {};
            SEARCH.ResetCategoryFilterCount(this.projects);
        },
        ClosePopup: function(type) {
            if (type === "Popup") {
                if (!this.search.changeMade) {
                    this.popup = {};
                } else {
                    this.simplePopup = {
                        show: true,
                        title: "Change Made",
                        topography: 1000
                    };
                }
            } else { // Simple
                this.simplePopup = {};
            }
        },
        ForceClosePopup: function() {
            this.search.changeMade = false;
            this.ClosePopup("Popup");
            this.ClosePopup("Simple");
        }
    },
    beforeMount: function() {
        ASSETS.Projects.SetTypes(this, this.distinctProjectTypes);
    },
    emits: [ "project" ]
};
</script>